import { SubscriptionAccess } from '../types/Subscription';

export const getAccessLimits = (accessLevel: SubscriptionAccess) => {
  return {
    qbankDaily: accessLevel === SubscriptionAccess.FREE ? 3 : Infinity,
    videos: accessLevel !== SubscriptionAccess.FREE,
    library: accessLevel !== SubscriptionAccess.FREE,
  };
};
